export var TextFieldType;
(function (TextFieldType) {
    TextFieldType["email"] = "email";
    TextFieldType["number"] = "number";
    TextFieldType["password"] = "password";
    TextFieldType["search"] = "search";
    TextFieldType["tel"] = "tel";
    TextFieldType["text"] = "text";
    TextFieldType["url"] = "url";
})(TextFieldType || (TextFieldType = {}));
